// @flow
import React from 'react';

import { StyledLabel } from '../../../common-utils/styledComponents';
import { Spacer } from '../../presentational/spacing/Spacer';
import { StyledExternalLink } from '../../presentational/ExternalLink';

import { SG_CNBC_LEGEND_TEXT } from './constants';

export const CNBCLegendContainer = () => (
  <StyledLabel>
    {SG_CNBC_LEGEND_TEXT}
    <Spacer x={5} />
    <StyledExternalLink
      href="https://confluentinc.atlassian.net/wiki/spaces/PM/pages/4732650042/CE+Automated+Credits+and+Global+Discounts"
      text="Read More"
    />
  </StyledLabel>
);
